import ServicePage from '@/components/templates/service-page'
import { staticServiceProps } from '@/lib/service-routes'

export const getStaticProps = staticServiceProps('/services/roofing/')

export default ServicePage
